/**
 * Artist Configuration
 *
 * This file contains artist-specific settings for the gallery.
 * Each deployment can have different values here.
 *
 * 4 sections: artist, site, theme, gallery
 *
 * HOW TO GET YOUR ARTIST UID:
 * 1. Log in to your gallery as the artist/admin
 * 2. Open browser console (F12)
 * 3. Run: firebase.auth().currentUser.uid
 * 4. Copy the UID and paste it below
 *
 * OR check Firestore:
 * - Go to Firebase Console → Firestore
 * - Open 'platformAdmins' collection
 * - Your document ID is your UID
 */

export const artistConfig = {
  // Artist Information (includes contact and art style)
  artist: {
    // Artist's Firebase UID. Kept null by default — in multi-tenant mode the UID
    // comes from the signed-in user (set via setDevTenantUid on login/signup)
    // or, later, from hostname-based tenant resolution. No tenant UID → no
    // Firestore fetch, and the app renders from these empty static defaults.
    uid: null,

    // Name displayed on works (e.g., "by Artist") and throughout the gallery
    name: '',

    // Contact
    bio: '',
    imageUrl: '',
    phone: '',
    socialMedia: {
      instagram: '', // TODO: Add Instagram URL if available
      facebook: '',  // TODO: Add Facebook URL if available
    },

    // Art Style
    movement: '',
    // Tag groups: artist-defined categories for organizing/filtering works.
    // Each group: { label, tags: [] }. Empty by default - artists create their own.
    tagGroups: [],
  },

  // Site Configuration (includes SEO defaults and legal)
  site: {
    domain: '',
    url: '',
    title: '',

    // SEO defaults (used at build time in index.html, overridden at runtime by per-page useHead())
    defaultTitle: '',
    defaultDescription: '',

    // Legal
    copyrightYear: '',
    copyrightHolder: '',
  },

  // Theme/Branding
  theme: {
    logoUrl: '',
    navbarBrand: 'name', // 'logo' | 'name' | 'none'
    iconUrl: '/icon-default.svg', // Favicon/site icon; App.vue falls back to /icon-default.svg
    headerColor: '#212529', // Default text color
    footerColor: null, // If null, uses headerColor
  },

  // Gallery Display Settings
  gallery: {
    unit: 'cm',       // default measurement unit for artwork sizes: 'cm' | 'inch'
    currency: 'eur',  // default currency for artwork prices — see ProfileSEOSettings for full list
    pagination: 'classical',  // 'classical' | 'infinite'
    itemsPerPage: 12,  // 6 | 9 | 12 | 18 | 24
    contactButtonText: 'Contact',  // Text for contact button in viewer
    // Viewer caption visibility settings
    viewerShowArtist: true,
    viewerShowCaption: true,
    viewerShowDescription: true,
    viewerShowYear: true,
    viewerShowTags: true,
    viewerShowSize: true,
    viewerShowFramed: true,
    viewerShowPrice: true,
    viewerShowSold: true,
    viewerShowPhone: false,
    viewerBackground: ''  // theme color key, or '' to follow the theme
  }
}
